import { type ColDef, type ColGroupDef, type GridApi } from 'ag-grid-community';

/**
 * Ajusta las propiedades de las columnas de forma de que sean
 * presentadas de la mejor forma posible en pantalla
 *
 * https://www.ag-grid.com/javascript-data-grid/column-sizing/
 *
 * @param {GridApi} gridApiLocal API de programación Grilla (https://www.ag-grid.com/javascript-data-grid/grid-api/)
 */
export const beautifyColumns = (gridApiLocal: GridApi) => {
  const columns: Array<ColDef | ColGroupDef> | undefined = gridApiLocal.getColumnDefs();

  if (columns) {
    const lastcol: ColDef = columns[columns.length - 1] as ColDef;
    // lastcol.flex = 1;
    // lastcol.headerName = 'TEST';

    gridApiLocal.updateGridOptions({ columnDefs: columns });

    const allColumnIds: Array<string> = [];
    columns.forEach((column: ColDef | ColGroupDef) => {
      if ('colId' in column) {
        // se verifica que el objeto tenga la propiedad ColId
        // https://camchenry.com/blog/typescript-type-guards
        allColumnIds.push((column as ColDef).colId + '');
      }
    });

    allColumnIds.pop();

    gridApiLocal.autoSizeColumns(allColumnIds, false);
  } else {
    gridApiLocal.autoSizeAllColumns(false);
  }
};
